import { PlusOutlined } from '@ant-design/icons'
import { useFormatter } from '@api/useFormatter'
import { useMetadata } from '@api/useMetadata'
import { useProducts } from '@api/useProducts'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { GraviButton } from '@gravitate-js/excalibrr'
import { sortNumeric } from '@utils/general'
import { Col, Form, Row } from 'antd'
import { useMemo } from 'react'

import { BolDetailRow } from '../Detail/BolDetailRow'
import { BOLHeaderForm } from './BOLHeaderForm'

export function BolRow({
  index,
  field,
  fields,
  bol,
  editing,
  removeBOL,
  attendantNote,
  isBackhaul,
  handleOpenImageModal,
  orderId,
  timezone,
}) {
  const { scopes } = useSecurityContext()
  const canEditBOLs = scopes.order_movements?.edit
  const { data: bolMetadata } = useMetadata('bol')
  const { useProductNamesQuery } = useProducts()
  const { data: productNames } = useProductNamesQuery()

  return (
    <>
      <BOLHeaderForm
        bol={bol}
        editing={editing}
        fields={fields}
        index={index}
        canEditBOLs={canEditBOLs}
        terminals={bolMetadata && [...new Set(bolMetadata.locations?.sort())]}
        removeBOL={removeBOL}
        stores={bolMetadata && sortNumeric(bolMetadata.stores, 'store_number')}
        attendantNote={attendantNote}
        handleOpenImageModal={handleOpenImageModal}
        orderId={orderId}
        timezone={timezone}
      />
      <Form.List name={[field.name, 'details']}>
        {(fields, { add, remove }) => {
          return (
            <>
              <BolDetailHeaderRow
                addDetail={() =>
                  add({
                    supplier: null,
                    product: null,
                    contract: null,
                    net: null,
                    gross: null,
                    compartment_index: null,
                  })
                }
                editing={editing}
                isBackhaul={isBackhaul}
              />
              {fields.map((_field, index) => (
                <BolDetailRow
                  key={index}
                  index={index}
                  editing={editing}
                  bolIndex={index}
                  detailIndex={index}
                  bolDetail={bol?.details[index]}
                  canEditBOLs={canEditBOLs}
                  products={productNames?.sort()}
                  suppliers={bolMetadata && [...new Set(bolMetadata.suppliers?.sort())]}
                  removeRow={() => remove(index)}
                  fields={fields}
                  isBackhaul={isBackhaul}
                />
              ))}
            </>
          )
        }}
      </Form.List>
    </>
  )
}
function BolDetailHeaderRow({ addDetail, editing, isBackhaul }) {
  const { formatVolume } = useFormatter()
  const formattedUnit = formatVolume(null, true)?.toUpperCase()

  const columnConfig = useMemo(() => {
    const cols = [
      { value: 'SUPPLIER', span: 4 },
      { value: 'PRODUCT', span: 4 },
      { value: 'CONTRACT', span: 3 },
      { value: `NET QTY (${formattedUnit})`, span: 3 },
      { value: `GROSS QTY (${formattedUnit})`, span: 3 },
      { value: 'POCKET', span: isBackhaul ? 4 : 3 },
      {
        value: (
          <>
            {editing && (
              <GraviButton
                onClick={addDetail}
                className='pr-3'
                style={{ float: 'right' }}
                appearance='outline'
                buttonText='Add Detail'
                icon={<PlusOutlined />}
              />
            )}
          </>
        ),
        span: 3,
      },
    ]

    // add price type column if not backhaul order
    if (!isBackhaul) {
      cols.splice(6, 0, { value: 'PRICE TYPE', span: 1 })
    }

    return cols
  }, [editing, formattedUnit, isBackhaul])
  return (
    <Row className='p-3 detail-header'>
      {columnConfig.map((c, i) => (
        <Col key={i} span={c.span}>
          {c.value}
        </Col>
      ))}
    </Row>
  )
}
